export default __webpack_public_path__ + "static/media/A4_Brochure_Mockup_5sm.d655586c.png";